// topoEditor/entities/ticketRef.js — "T#123" becomes a link to a ticket of the message center (bigplan
// backend/message-center, decision D-16). Convention = the reference as people write it; the value stores nothing else.
//
// The T in front keeps it apart from tags like "#Testreihe"; it must start a word, so "AT#1" stays text.
// No authoring UI: typing T#123 is enough. The frontend form is a real link (the message center page), because the
// reference is only shown inside the backend.

import { escapeHtml } from "../render.js";

const TICKET_PATTERN = /\bT#(\d+)\b/g;

const DEFAULT_HREF = (id) => "/messagecenter.php?ticket=" + encodeURIComponent(id);

export function ticketRefEntity({ hrefFor = DEFAULT_HREF, labels = {} } = {}) {
    const tokenTitle = labels.tokenTitle ?? "Ticket";
    return {
        kind: "ticketref",
        pattern: TICKET_PATTERN,
        parse: (m) => ({ id: m[1] }),
        renderHtml: (data, idx) =>
            '<span class="topo2-link--intern topo2-editor-ticketref" data-kind="ticketref" data-idx="' + idx +
            '" data-ticket-id="' + escapeHtml(data.id) + '" title="' + escapeHtml(tokenTitle + " " + data.id) + '">T#' +
            escapeHtml(data.id) + "</span>",
        serialize: (data) => "T#" + data.id,
        renderFrontendHtml: (data) =>
            '<a class="topo2-link--intern topo2-ticketref" data-ticket-id="' + escapeHtml(data.id) + '" href="' +
            escapeHtml(hrefFor(data.id)) + '">T#' + escapeHtml(data.id) + "</a>",
    };
}
